import React from 'react';

const NebulaContext = React.createContext();

export default NebulaContext;
